var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSpreadsheet = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 24h-13c-1.379 0-2.5-1.122-2.5-2.5v-16c0-1.378 1.121-2.5 2.5-2.5h2c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.827 0-1.5.673-1.5 1.5v16c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-16c0-.827-.673-1.5-1.5-1.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c1.379 0 2.5 1.122 2.5 2.5v16c0 1.378-1.121 2.5-2.5 2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 6h-7c-.827 0-1.5-.673-1.5-1.5v-2c0-.276.224-.5.5-.5h2.05c.232-1.14 1.243-2 2.45-2s2.218.86 2.45 2h2.05c.276 0 .5.224.5.5v2c0 .827-.673 1.5-1.5 1.5zm-7.5-3v1.5c0 .276.225.5.5.5h7c.275 0 .5-.224.5-.5v-1.5h-2c-.276 0-.5-.224-.5-.5 0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5c0 .276-.224.5-.5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 21h-13c-.276 0-.5-.224-.5-.5v-12c0-.276.224-.5.5-.5h13c.276 0 .5.224.5.5v12c0 .276-.224.5-.5.5zm-12.5-1h12v-11h-12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 21c-.276 0-.5-.224-.5-.5v-12c0-.276.224-.5.5-.5s.5.224.5.5v12c0 .276-.224.5-.5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 12h-13c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13c.276 0 .5.224.5.5s-.224.5-.5.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 15h-13c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13c.276 0 .5.224.5.5s-.224.5-.5.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 18h-13c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h13c.276 0 .5.224.5.5s-.224.5-.5.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpreadsheet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spreadsheet.ac6a6bcd.svg";
export { ForwardRef as ReactComponent };